import routes from 'sitewide-js/core_pre_webpack/routes';
import * as ApiUtils from 'js/utils/api_utils';

export function cancelTasteOfMentionsTest() {
  const path = routes.cancel_taste_of_mentions_test_redux_api_v0_mentions_path({
    subdomain_param: 'api',
  });

  return ApiUtils.post(path);
}
